/* once.icon.svg.js */

module.exports = {
    icon: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" xml:space="preserve">
        <path class="foreground-gl" d="M10,19.86a9.9,9.9,0,1,1,9.9-9.9A9.91,9.91,0,0,1,10,19.86ZM10,1.44A8.52,8.52,0,1,0,18.5,10,8.53,8.53,0,0,0,10,1.44Z" transform="translate(-0.08 -0.05)"/>
        <path class="foreground-gl" d="M8.12,16.06l6.7-6L8,3.94S8.12,16.21,8.12,16.06Z" transform="translate(-0.08 -0.05)"/>
        </svg> 
    `
};
